module.exports = __webpack_public_path__ + "static/media/calzificio-bloch-calzificio-reggiano.4ab6324a.svg";